import * as yup from "yup";

import validator from "validator";

/**
 * Expresión regular para validar email con dominio completo
 * Requiere: usuario@dominio.extension
 * - Al menos un caracter antes del @
 * - Dominio después del @ con al menos un punto
 * - Extensión de dominio de al menos 2 caracteres
 */
const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Schema de validación para email utilizando Yup
 * Valida que el email tenga un formato válido con dominio completo
 */
export const EmailSchema = yup.object().shape({
    email: yup
        .string()
        .required()
        .email()
        .matches(EMAIL_REGEX, 'Email must have a valid domain')
});

export const EmailSchemaisEmail = yup.object().shape({
    email: yup
        .string()
        .required("Email is required")
        .test("is-valid-email", "Email must be valid", (value) =>
            validator.isEmail(value || "")
        )
});

/**
 * Valida si un email tiene un formato válido
 * @param {string} email - Email a validar
 * @returns {Promise<boolean>} - true si es válido, false si no lo es
 */
export const validateEmailFormat = async (email) => {
    try {
        await EmailSchemaisEmail.validate({ email });
        return true;
    } catch (error) {
        return false;
    }
};
